import type { SduiDocument } from "../types/sdui.js";

/** Shared viewer session state (document + selection). Components read/write via callbacks from main. */
export interface ViewerSession {
  doc: SduiDocument | null;
  selectedKey: string | null;
  viewMode: "component" | "page";
  sourceId: string;
  theme: string;
}

export function createSession(): ViewerSession {
  return {
    doc: null,
    selectedKey: null,
    viewMode: "page",
    sourceId: "",
    theme: "Dark",
  };
}
